import React, { useEffect, useState } from 'react'
import { Lottie } from '@crello/react-lottie'

import { upload } from '../api'

import Layout from '../components/Layout'
import Text from '../components/Text'

import thanks from '../static/thanks.json'
import virus from '../static/virus.json'

const shareUrl = window.location.href

const Finish = ({ isUploading }) => {
  if (isUploading) {
    return (
      <Layout>
        <Layout>
          <Text large center>
            Please wait, uploading your audio files...
          </Text>
        </Layout>

        <Layout>
          <Lottie height={200} config={{ animationData: virus, autoplay: true, loop: true }} />
        </Layout>
      </Layout>
    )
  }

  return (
    <Layout>
      <Layout>
        <Text large center>
          You are done! The community thanks you 😊
        </Text>
      </Layout>

      <Layout>
        <Text center>Please share this voicemed.io website with your network.</Text>

        <Layout>
          <div className="share-links-container">
            <a
              href={`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`}
              title="Share on Facebook"
              target="_blank"
              className="share-btn btn-facebook"
            >
              <i className="fab fa-facebook"></i>
            </a>

            <a
              href={`http://twitter.com/home?status=${shareUrl}`}
              title="Share on Twitter"
              target="_blank"
              className="share-btn btn-twitter"
            >
              <i className="fab fa-twitter"></i>
            </a>

            <a
              href={`https://wa.me/?text=${shareUrl}`}
              title="Share on Whatsapp"
              target="_blank"
              className="share-btn btn-whatsapp"
            >
              <i className="fab fa-whatsapp"></i>
            </a>
          </div>
        </Layout>
      </Layout>

      <Layout>
        <Lottie height={200} config={{ animationData: thanks, autoplay: true, loop: true }} />
      </Layout>
    </Layout>
  )
}

export default ({ data, blobs }) => {
  const [isUploading, setUploading] = useState(true)

  async function onUpload() {
    upload({
      blobs,
      ...data
    }).then(() => setUploading(false))

    localStorage.clear()
  }

  useEffect(() => {
    onUpload()
  }, [])

  return <Finish isUploading={isUploading} />
}
